/**
 * WE Agent Report MV2 query API.
 */
import api from "@/lib/api";

export const WE_AGENT_REPORT_QUERY_KEY = "we-agent-report";

export async function fetchWeAgentReportFromApi(date, signal) {
  const params = date ? { date } : {};
  const response = await api.get("/we-agent/report", { params, signal });
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
  return response.data;
}

export async function approveWeAgentTask(weTaskId) {
  const response = await api.post(`/we-agent/tasks/${weTaskId}/approve`);
  return response.data;
}
